import { Injectable } from '@angular/core';
import {BaseService} from '../../base.service';

@Injectable({
  providedIn: 'root'
})
export class LoyaltyService extends BaseService {
  getListLoyaltyWithProduct(query?: {page: any , page_size: any}) {
    return this.get<any>('/loyalty/products', {params: query});
  }
  getListLoyalty(query?: {page: any , page_size: any}) {
    return this.get<any>('/loyalty', {params: query});
  }
  getListLoyaltyWithProductId(query: { productId: any}) {
    return this.get<any>(`/product/loyalty`, {params : query});
  }

  requestLoyalty(query: { phone: any}) {
    return this.get<any>(`/user/user/request-loyalty`, {params : query});
}
  authenticateLoyalty(body: {token: string, otp: string}) {
    return this.post<any>('/user/user/confirm-loyalty', body);
  }
  checkRegisLoyalty() {
    return this.get<any>('/user/user/loyalty');
  }

  assignGiftCodeByCampaign(id: string , body: {loyaltyCampaignType: number, loyaltyCampaignObject: string, loyaltyGiftCode: string }) {
    return this.put<any>(`/product/loyalty/${id}`, body);
  }
  // deleteTicket(query?: any) {
  //   return this.delete<any>('/stringee/ticket',  {params: query});
  // }

  campaignAll(barcode: string) {
    return this.get<any>(`/loyalty/campaign-all/${barcode}`);
  }

  settingCampaignAll(body: any) {
    return this.post<any>('/loyalty/setting-campaign-all', body);
  }
}
